module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3QgeD0iLjUiIHk9Ii41IiB3aWR0aD0iMjMiIGhlaWdodD0iMjMiIHJ4PSIxLjUiIHN0cm9rZT0iIzFFNDY0NiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/checkbox.svg
// module id = 1682
// module chunks = 5